"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTTPContentType = exports.HTTPHeader = exports.HTTPAuthenticationScheme = exports.HTTPMethod = exports.FetchOptionCredentials = exports.FetchOptionMode = exports.FetchOptionReferrer = exports.FetchOptionRedirect = exports.FetchOptionCache = void 0;
var FetchOptionCache;
(function (FetchOptionCache) {
  FetchOptionCache["default"] = "default";
  FetchOptionCache["noCache"] = "no-cache";
  FetchOptionCache["reload"] = "reload";
  FetchOptionCache["forceCache"] = "force-cache";
  FetchOptionCache["onlyIfCached"] = "only-if-cached";
})(FetchOptionCache = exports.FetchOptionCache || (exports.FetchOptionCache = {}));
var FetchOptionRedirect;
(function (FetchOptionRedirect) {
  FetchOptionRedirect["manual"] = "manual";
  FetchOptionRedirect["follow"] = "follow";
  FetchOptionRedirect["error"] = "error";
})(FetchOptionRedirect = exports.FetchOptionRedirect || (exports.FetchOptionRedirect = {}));
var FetchOptionReferrer;
(function (FetchOptionReferrer) {
  FetchOptionReferrer["noReferrer"] = "no-referrer";
  FetchOptionReferrer["client"] = "client";
})(FetchOptionReferrer = exports.FetchOptionReferrer || (exports.FetchOptionReferrer = {}));
var FetchOptionMode;
(function (FetchOptionMode) {
  FetchOptionMode["noCors"] = "no-cors";
  FetchOptionMode["cors"] = "cors";
  FetchOptionMode["sameOrigin"] = "same-origin";
})(FetchOptionMode = exports.FetchOptionMode || (exports.FetchOptionMode = {}));
var FetchOptionCredentials;
(function (FetchOptionCredentials) {
  FetchOptionCredentials["include"] = "include";
  FetchOptionCredentials["omit"] = "omit";
  FetchOptionCredentials["sameOrigin"] = "same-origin";
})(FetchOptionCredentials = exports.FetchOptionCredentials || (exports.FetchOptionCredentials = {}));
var HTTPMethod;
(function (HTTPMethod) {
  HTTPMethod["get"] = "GET";
  HTTPMethod["post"] = "POST";
  HTTPMethod["put"] = "PUT";
  HTTPMethod["delete"] = "DELETE";
  HTTPMethod["patch"] = "PATCH";
})(HTTPMethod = exports.HTTPMethod || (exports.HTTPMethod = {}));
var HTTPAuthenticationScheme;
(function (HTTPAuthenticationScheme) {
  HTTPAuthenticationScheme["basic"] = "Basic";
  HTTPAuthenticationScheme["bearer"] = "Bearer";
  HTTPAuthenticationScheme["digest"] = "Digest";
  HTTPAuthenticationScheme["hoba"] = "HOBA";
  HTTPAuthenticationScheme["mutual"] = "Mutual";
  HTTPAuthenticationScheme["negotiate"] = "Negotiate";
  HTTPAuthenticationScheme["oauth"] = "OAuth";
  HTTPAuthenticationScheme["scramSha1"] = "SCRAM-SHA-1";
  HTTPAuthenticationScheme["scramSha256"] = "SCRAM-SHA-256";
  HTTPAuthenticationScheme["vapid"] = "vapid";
})(HTTPAuthenticationScheme = exports.HTTPAuthenticationScheme || (exports.HTTPAuthenticationScheme = {}));
var HTTPHeader;
(function (HTTPHeader) {
  HTTPHeader["contentType"] = "Content-Type";
  HTTPHeader["authorization"] = "Authorization";
  HTTPHeader["csrfToken"] = "X-CSRF-Token";
  HTTPHeader["accept"] = "Accept";
})(HTTPHeader = exports.HTTPHeader || (exports.HTTPHeader = {}));
var HTTPContentType;
(function (HTTPContentType) {
  HTTPContentType["json"] = "application/json";
  HTTPContentType["jsonApi"] = "application/vnd.api+json";
  HTTPContentType["formUrlEncoded"] = "application/x-www-form-urlencoded";
  HTTPContentType["multipartFormData"] = "multipart/form-data";
})(HTTPContentType = exports.HTTPContentType || (exports.HTTPContentType = {}));